import styled from 'styled-components';

export const BreadcrumbStyles = styled.div`
  overflow: hidden; // overflow needed here for desktop to display breadcrumbs with ellipsis

  @media (max-width: calc(${props => props.theme.breakpoints.desktop} - 1px)) {
    ${props =>
      props.$hasBreadcrumbs &&
      `
        padding: 0.5rem;
      `}
  }
  .breadcrumb-container {
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;
  }

  .ellipsis-icon {
    padding: 8px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ellipsis-icon.active {
    background-color: ${props => props.theme.colors.blue10};
  }

  .bc-dropdown {
    display: none;
    position: absolute;
    top: 90%;
    left: 8px;
    min-width: 150px;
    background-color: ${props => props.theme.colors.blue10};
    white-space: nowrap;
  }

  .bc-dropdown.active {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    padding: 0.625rem;
    cursor: default;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
    max-width: 85%;
  }

  .bc-dropdown-item {
    font-size: 0.875rem;
    color: ${props => props.theme.colors.darkClaytonBlue};

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: 100%;

    a {
      text-decoration: none;
      color: ${props => props.theme.colors.darkClaytonBlue};
    }
    &:last-child {
      font-weight: 600;
    }
  }

  .breadcrumb {
    display: flex;

    flex-wrap: nowrap;
    overflow: hidden;
    align-items: center;
    min-width: 0;

    list-style: none;
    margin: 0;
    padding: 0;

    font-weight: 400;
    font-size: 0.875rem;
    font-family: ${props => props.theme.fonts.primary};
    color: ${props => props.theme.colors.claytonBlue};

    .breadcrumb-item {
      a {
        text-decoration: none;
      }
      &:last-child {
        font-weight: 600;
      }

      &:first-child {
        ${props =>
          props.$showLeadingSlash &&
          `
          &:before {
            content: '/';
            display: inline-block;
            padding-right: 0.125rem;
            color: ${props.theme.colors.bedtime};
            font-weight: 400;
          }
        `}
      }
    }
  }

  .breadcrumb-item + .breadcrumb-item {
    &:before {
      content: '/';
      display: inline-block;
      padding-left: 0.125rem;
      padding-right: 0.125rem;
      color: ${props => props.theme.colors.bedtime};
      font-weight: 400;
    }
  }
`;
